module.exports = __webpack_public_path__ + "img/artboard1.cbb210ae.png";